import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './NewYearEventBanner.css';

interface NewYearEventBannerProps {
  onClose?: () => void;
}

const NewYearEventBanner: React.FC<NewYearEventBannerProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateEvent = () => {
    navigate('/event');
    if (onClose) onClose();
  };

  return (
    <div className="new-year-banner">
      <div className="scroll-container">
        <div className="scroll-left-roll"></div>
        <div className="scroll-right-roll"></div>
        <div className="firework firework-1">❤️</div>
        <div className="firework firework-2">❤️</div>
        <div className="firework firework-3">❤️</div>
        <div className="firework firework-4">❤️</div>
        <div className="scroll-content">
          <div className="scroll-logo left">
            <img src="/images/logo.png" alt={t('newYearBanner.logoAlt')} />
          </div>
          <div className="scroll-message">
            <h2>{t('newYearBanner.title')}</h2>
            <div className="poem-container">
              <p className="poem-line">{t('newYearBanner.poem.line1')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line2')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line3')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line4')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line5')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line6')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line7')}</p>
              <p className="poem-line">{t('newYearBanner.poem.line8')}</p>
            </div>

            <div className="action-container" style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <p className="subtitle" style={{ margin: 0 }}>{t('newYearBanner.subtitle')}</p>
              <button
                onClick={handleCreateEvent}
                className="submit-btn"
                style={{
                  maxWidth: '300px',
                  fontSize: '1.1rem',
                  padding: '12px 24px',
                  background: 'linear-gradient(to bottom, #d4af37, #aa8c2c)',
                  border: '1px solid #ffd700',
                  boxShadow: '0 4px 15px rgba(212, 175, 55, 0.4)'
                }}
              >
                {t('newYearBanner.button')}
              </button>
            </div>
          </div>
          <div className="scroll-logo right">
            <img src="/images/logo.png" alt={t('newYearBanner.logoAlt')} />
          </div>
        </div>
        {onClose && (
          <button className="close-banner-btn" onClick={onClose} title={t('newYearBanner.close')}>
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default NewYearEventBanner;
